import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SettingsService } from '../settings/settings.service';
import { ControlParams, IControlParams } from '../models/models.lib';
import { ApiService } from '../api/api.service';
import { FormModes } from '../common/constants.lib';
import { Settings } from '../common/obj.lib';
import { environment } from '../../environments/environment';
const { apiUrl } = environment;

export abstract class CasiControlParamsService extends BehaviorSubject<any> {
  public loading: boolean = false;
  // private settings: Settings = this.settingsService.getSettings();

  constructor(
    private http: HttpClient,
  ) {
    super(null);
  }

  public query(): void {
    this.fetch().subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(): Observable<ControlParams> {
    this.loading = true;
    // this.settings = this.settingsService.getSettings();
    return this.http.get(encodeURI(`${apiUrl}/controlWithImages`))
      .pipe(
        map((response: any, i) => {
          return <IControlParams>response;
        }),
        map(r => ControlParams.create(r)),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class ControlParamsService extends CasiControlParamsService {


  constructor(
    http: HttpClient,
    private apiService: ApiService
  ) {
    super(http);
  }

  get(): Promise<ControlParams> {
    return this.apiService.getHttpCallAsPromise('controlWithImages', 'get');
  }

  update(p: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`updatecontrol`, p, 'update');
  }

}
